import { render } from "./SaiyoFlow.vue?vue&type=template&id=07058e54&scoped=true"
import script from "./SaiyoFlow.vue?vue&type=script&lang=js"
export * from "./SaiyoFlow.vue?vue&type=script&lang=js"

import "./SaiyoFlow.vue?vue&type=style&index=0&id=07058e54&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07058e54"]])

export default __exports__